import { VoucherUserSelectedPksWithVoucherStatus } from '../../components/organisms/VoucherSelectUsersList/VoucherSelectUsersList';
import * as constants from '../constants';

export const setUsersVoucherList = (userPks: VoucherUserSelectedPksWithVoucherStatus[], usersDataList: any = []) => {
  return {
    type: constants.SET_USERS_VOUCHER_LIST,
    userPks,
    usersDataList
  };
};

export const setVoucherFormValues = (formValues: any) => {
  return {
    type: constants.SET_VOUCHER_FORM_VALUES,
    formValues,
  };
};
